import isEqual from 'lodash/isEqual';
import includes from 'lodash/includes';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useStore } from 'react-redux';
import { renderRoutes } from 'react-router-config';
import RouterLoader from 'router/RouterLoader';
import { Route, useLocation } from 'react-router-dom';
import routes from 'router/routes';
import NotFound from 'pages/not-found';
import ErrorUtils from 'utils/error-utils';
import { getPath, reduceStateForRoute } from 'utils/navigator-utils';
function Navigator({ extraProps }) {
    const dispatch = useDispatch();
    const store = useStore();
    const location = useLocation();
    const [isLoading, setIsLoading] = useState(false);
    const [isNotFound, setIsNotFound] = useState(false);
    const [path, setPath] = useState(getPath(location));
    const prevLocationRef = useRef(null);
    useEffect(() => {
        const prevLocation = prevLocationRef.current;
        prevLocationRef.current = location;
        if (prevLocation === null)
            return;
        if (prevLocation.pathname === '/search' &&
            location.pathname === '/search' &&
            prevLocation.search !== location.search &&
            includes(prevLocation.search, 'spot-id') &&
            !includes(location.search, 'spot-id')) {
            // do not fetch new data when the Spot Details panel is closed
            return;
        }
        if (location.pathname !== prevLocation.pathname ||
            location.search !== prevLocation.search ||
            !isEqual(location.state, prevLocation.state)) {
            reduceStateForRoute(prevLocation, location, dispatch, store.getState, setIsLoading)
                .then(() => {
                setPath(getPath(location));
                setIsNotFound(false);
                setIsLoading(false);
            })
                .catch(error => {
                ErrorUtils.sendSentryException(error);
                setIsNotFound(true);
                setIsLoading(false);
            });
        }
    }, [location, dispatch, store]);
    return (<Route location={{ pathname: path }} render={() => isNotFound ? (<NotFound />) : isLoading ? (<RouterLoader />) : (renderRoutes(routes, extraProps))}/>);
}
export default Navigator;
